module.exports = __webpack_public_path__ + "img/chauffe-marcel_02_icone.d569313b.svg";